import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-static';

const SETTLE_TIME = 3000;
const USER_SCROLL_EVENTS = ['wheel', 'touchstart', 'keydown', 'mousedown'];

export function scrollToElement(element, { smooth = false } = {}) {
  const behavior = smooth ? 'smooth' : 'auto';
  element.scrollIntoView({ behavior });

  if (typeof ResizeObserver === 'undefined') {
    return;
  }

  const observer = new ResizeObserver(() => element.scrollIntoView({ behavior }));
  const stop = () => {
    observer.disconnect();
    clearTimeout(timer); // eslint-disable-line no-use-before-define
    USER_SCROLL_EVENTS.forEach(event => window.removeEventListener(event, stop));
  };
  const timer = setTimeout(stop, SETTLE_TIME);

  for (let node = element.parentElement; node; node = node.parentElement) {
    observer.observe(node);
  }
  USER_SCROLL_EVENTS.forEach(event => window.addEventListener(event, stop, { passive: true }));
}

function scrollToHash(hash) {
  if (typeof window === 'undefined' || !hash || hash === '#') {
    return;
  }

  let id;
  try {
    id = decodeURIComponent(hash.slice(1));
  } catch (err) {
    return;
  }

  const deadline = Date.now() + 2000;
  const attempt = () => {
    const element = document.getElementById(id);
    if (element) {
      scrollToElement(element);
    } else if (Date.now() < deadline) {
      window.requestAnimationFrame(attempt);
    }
  };

  attempt();
}

class AnchorScroll extends PureComponent {
  componentDidMount() {
    scrollToHash(this.props.location.hash);
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    const moved =
      prevProps.location.hash !== location.hash ||
      prevProps.location.pathname !== location.pathname;

    if (moved) {
      scrollToHash(location.hash);
    }
  }

  render() {
    return null;
  }
}

AnchorScroll.propTypes = {
  location: PropTypes.shape({
    hash: PropTypes.string,
    pathname: PropTypes.string,
  }).isRequired,
};

export default withRouter(AnchorScroll);



// WEBPACK FOOTER //
// /tmp/build_2cb81483/src/components/main/utils/AnchorScroll.js